import { Toaster as Sonner } from "sonner";
import { useTheme } from "../../contexts/ThemeContext";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { isDark } = useTheme();

  return (
    <Sonner
      theme={isDark ? "dark" : "light"}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:dark:bg-primary-900 group-[.toaster]:text-primary-950 group-[.toaster]:dark:text-white group-[.toaster]:border-primary-200 group-[.toaster]:dark:border-primary-800 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-primary-600 group-[.toast]:dark:text-primary-400",
          actionButton:
            "group-[.toast]:bg-primary-950 group-[.toast]:dark:bg-white group-[.toast]:text-white group-[.toast]:dark:text-primary-950",
          cancelButton:
            "group-[.toast]:bg-primary-100 group-[.toaster]:dark:bg-primary-800 group-[.toast]:text-primary-600 group-[.toast]:dark:text-primary-400",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
